<atn-ds-widget title="General">
  <ng-container actions>
    @if (canEditAppSg()) {
      <i
        class="atn-icon atn-edit atn-blue"
        (click)="editClickHandler()"
      ></i>
    }
  </ng-container>

  <div class="atn-app-general-tab">
    <div class="atn-app-general-tab__field">
      <span><b>Icon</b></span>
      <i
        class="atn-icon atn-{{ appIconSg() }} atn-blue"
        data-test-id="icon-field"
      ></i>
    </div>
    <div
      class="atn-app-general-tab__field"
      data-test-id="name-field"
    >
      <span><b>Name</b></span>
      <atn-ds-value [value]="appNameSg()" />
    </div>
    <div
      class="atn-app-general-tab__field"
      data-test-id="alias-field"
    >
      <span><b>Alias</b></span>
      <atn-ds-value [value]="appAliasSg()" />
    </div>
    <div
      class="atn-app-general-tab__field"
      data-test-id="description-field"
    >
      <span><b>Description</b></span>
      <atn-ds-value [value]="appDescriptionSg()" />
    </div>
  </div>
</atn-ds-widget>

<atn-admin-app-modal />
